/**
 * O que faz: mantém a altura da tela e comunica o carregamento de uma rota lazy.
 * Onde usa: fallback das páginas protegidas e administrativas.
 * Conexões: Suspense do React e layout principal.
 * Tabelas: nenhuma.
 * Data: 28/08/2026
 */

interface CarregamentoRotaProps {
  label?: string;
}

export function CarregamentoRota({ label = 'Carregando tela…' }: CarregamentoRotaProps) {
  return (
    <div className="flex h-full min-h-[16rem] items-center justify-center" role="status" aria-live="polite">
      <span className="text-sm text-slate-500">{label}</span>
    </div>
  );
}
